"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleEscrowFactoryGetterMock__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [{
    internalType: "address",
    name: "titleEscrowFactory",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "callCreate",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "tokenRegistry",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "getAddress",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "_titleEscrowAddress",
    type: "address"
  }],
  name: "setAddress",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "0x608060405234801561001057600080fd5b5061029f806100206000396000f3fe608060405234801561001057600080fd5b50600436106100415760003560e01c80637cf99ced146100465780638cb84e181461005b578063e30081a01461008a575b600080fd5b6100596100543660046101fc565b6100ba565b005b61006e6100693660046101fc565b610139565b6040516001600160a01b03909116815260200160405180910390f35b610059610098366004610228565b600080546001600160a01b0319166001600160a01b0392909216919091179055565b604051631e02403760e21b8152600481018290526001600160a01b0383169063780900dc90602401602060405180830381600087803b1580156100fc57600080fd5b505af1158015610110573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610134919061024c565b505050565b600080546001600160a01b03166101d05760405163119709c360e31b81526001600160a01b038416600482018190526024820184905290638cb84e189060440160206040518083038186803b15801561019157600080fd5b505afa1580156101a5573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906101c9919061024c565b90506101de565b506000546001600160a01b03165b92915050565b6001600160a01b03811681146101f957600080fd5b50565b6000806040838503121561020f57600080fd5b823561021a816101e4565b946020939093013593505050565b60006020828403121561023a57600080fd5b8135610245816101e4565b9392505050565b60006020828403121561025e57600080fd5b8151610245816101e456fea2646970667358221220dab7df6cb4c2d19c9476349837f31cbf8442f7cebef46a15bce43a2219b0a99764736f6c63430008090033";

const isSuperArgs = xs => xs.length > 1;

class TitleEscrowFactoryGetterMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(overrides) {
    return super.deploy(overrides || {});
  }

  getDeployTransaction(overrides) {
    return super.getDeployTransaction(overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TitleEscrowFactoryGetterMock__factory = TitleEscrowFactoryGetterMock__factory;

_defineProperty(TitleEscrowFactoryGetterMock__factory, "bytecode", _bytecode);

_defineProperty(TitleEscrowFactoryGetterMock__factory, "abi", _abi);